import { Form, Input, Switch, Typography } from 'antd';
import '@app/components/SalesFunnelFormContent/styles/SalesFunnelFormContent.desktop.scss';

import { ClientServicesSelect } from '@app/components';
import {
  ERROR_REQUIRED_FIELD,
  MAX_LENGTH_MESSAGE,
  MIN_THREE_SYMBOLS,
} from '@app/constants';

import type { FormInstance } from 'antd';
import type { FC } from 'react';

type Props = {
  form: FormInstance;
};

const { Text } = Typography;
const { TextArea } = Input;
const { useWatch } = Form;

const ruleIsRequire = [
  {
    required: true,
    message: ERROR_REQUIRED_FIELD,
  },
];
export const SalesFunnelFormContent: FC<Props> = ({ form }) => {
  const autoStageSwitch = useWatch('UseAutoStageSwitch', form);
  const selectedServices = useWatch('ClientServices', form);

  const handleChange = (value: number[]) => {
    form.setFieldsValue({ ClientServices: value });
  };

  return (
    <div className="container sales-funnel-form-container">
      <div className="item-container">
        <Text strong className="label-require">
          Название воронки
        </Text>
        <Form.Item
          name="Name"
          rules={[
            ...ruleIsRequire,
            {
              min: 3,
              message: MIN_THREE_SYMBOLS,
            },
            {
              max: 120,
              message: MAX_LENGTH_MESSAGE,
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
      </div>

      <div className="item-container">
        <Text strong className="label">
          Описание воронки
        </Text>
        <Form.Item
          name="Description"
          rules={[
            {
              max: 600,
              message: MAX_LENGTH_MESSAGE,
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>
      </div>
      {/* Временно скрыто в рамках задачи issue/5825 */}
      {/* <div className="services-section__container">
        <Form.Item
          name="UseAutoStageSwitch"
          valuePropName="checked"
          className="mg-0"
        >
          <Switch />
        </Form.Item>

        <Text strong style={{ marginLeft: '10px' }}>
          Синхронизация с журналом записи ыва
        </Text>
        <Text className="services-section__description" type="secondary">
          Автоматическое добавление клиента в воронку продаж и перемещение по
          этапам воронки в соответствии со статусом записи.
        </Text>
      </div> */}
      {autoStageSwitch && (
        <>
          <div className="services-section__container">
            <Form.Item
              name="SyncStagesInExistedLeads"
              valuePropName="checked"
              className="mg-0"
            >
              <Switch />
            </Form.Item>

            <Text strong style={{ marginLeft: '10px' }}>
              Синхронизировать существующие лиды
            </Text>
            <Text className="services-section__description" type="secondary">
              Синхронизация может занять несколько минут после сохранения
            </Text>
          </div>
          <Form.Item
            layout="vertical"
            label="Условие: Услуги в записи"
            colon
            name="ClientServices"
          >
            <ClientServicesSelect
              value={selectedServices}
              onChange={handleChange}
            />
          </Form.Item>
        </>
      )}
    </div>
  );
};
